import { InvoiceDto } from '@up/data';

export class BillingAuthorizeInvoiceResponseDto {
  hasBeenPaid?: boolean;
  invoice: InvoiceDto;
}
